import React from 'react';
import styled from 'styled-components';
import { BsArrowClockwise } from 'react-icons/bs';

const MenuContainer = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: ${props => props.theme.colors.background};
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 100;
  min-width: 200px;
  overflow: hidden;
`;

const MenuItem = styled.button`
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${props => props.theme.colors.text};

  &:hover {
    background: ${props => props.theme.colors.secondaryBackground};
  }

  svg {
    font-size: 18px;
  }
`;

const Menu = ({ onRefreshConversation }) => {
  return (
    <MenuContainer>
      <MenuItem onClick={onRefreshConversation}>
        <BsArrowClockwise />
        Làm mới cuộc trò chuyện
      </MenuItem>
    </MenuContainer>
  );
};

export default Menu;